import {BehaviorSubject} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private spinnerEvents: BehaviorSubject<string>;

  constructor() {
    this.spinnerEvents = new BehaviorSubject<string>('show');
  }

  get events() {
    return this.spinnerEvents.asObservable();
  }

  public hide(): void {
    this.spinnerEvents.next('hide');
  }

  public show(): void {
    this.spinnerEvents.next('show');
  }
}
